import VueRouter from  'vue-router';
import pizzaPage from "./pages/pizzaPage";
import drinksPage from "./pages/drinksPage";
import cartPage from "./pages/cartPage";
import fingerfoodPage from "./pages/fingerfoodPage";



export default new VueRouter({

    routes: [
        {
            path: '/',
            component: pizzaPage
        },
        {
            path: '/drinks',
            component: drinksPage
        },
        {
            path: '/cart',
            component: cartPage
        },
        {
            path: '/fingerfood',
            component: fingerfoodPage
        }
    ],
});